import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const [getdate, setGetdate] = useState(0);
  useEffect(() => {
    let getdate = new Date().getFullYear();
    setGetdate(getdate);
  }, []);
  return (
    <>
      <div className="footer fwidth">
        <div className="abs-list ftrShape1"></div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-2 col-lg-12 col-sm-12 col-xs-12 d-flex">
              <div className="ftr-logo">
                {" "}
                <Link to="/">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/logo.png"
                    alt="TAFS"
                  />
                </Link>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 col-sm-12 col-xs-12">
              <div className="quick-link">
                <h3>Quick Links</h3>
                <ul>
                  <li>
                    <Link to="/ClassesUKGtoV"> Classes UKG - V </Link>
                  </li>
                  <li>
                    <Link to="/ClassesVItovIII"> Classes VI - VIII </Link>
                  </li>
                  <li>
                    <Link to="/ClassesIXtoX"> Classes IX & X </Link>
                  </li>
                  <li>
                    <Link to="/ClassesXItoXII"> Classes XI & XII </Link>
                  </li>
                  <li>
                    <Link to="/BusRoutes"> Bus Route </Link>
                  </li>
                  <li>
                    <Link to="/Magazine"> Online Magazine / Newsletter </Link>
                  </li>
                  <li>
                    <Link to="/AlumniForm"> Alumni Form </Link>
                  </li>
                  <li>
                    <Link to="/FeeStructure"> Fee Structure </Link>
                  </li>
                  <li>
                    <Link to="/TransportRules"> Transport Rules </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-3 col-lg-6 col-sm-12 col-xs-12 address">
              <h3>Contact us</h3>
              <p>
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/loc.png"
                  alt="AFS"
                />
                <span>
                  <Link
                    to="https://maps.app.goo.gl/32bxM4va7rUrr9kL6"
                    target="_blank"
                  >
                    {" "}
                    Subroto Park, Delhi Cantt. , New Delhi, India
                  </Link>
                </span>
              </p>

              <p>
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/call.png"
                  alt="AFS"
                />{" "}
                <span>
                  <a href="tel: +91-11-25693063"> +91-11-25693063</a> |{" "}
                  <a href="tel: +91-11-25693627">+91-11-25693627</a>
                </span>
              </p>
              <p>
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/mail.png"
                  alt="AFS"
                />{" "}
                <span>
                  {" "}
                  <a href="mailto: tafsdelhi@gmail.com">
                    {" "}
                    tafsdelhi@gmail.com
                  </a>{" "}
                </span>
              </p>
            </div>
            <div className="col-xl-3 col-lg-6 col-sm-12 col-xs-12">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7006.892805663802!2d77.15414!3d28.586382!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1d1c79c8edb3%3A0x981d1a21e78f3f6e!2sTHE%20AIR%20FORCE%20SCHOOL%2C%20SUBROTO%20PARK!5e0!3m2!1sen!2sin!4v1743658031660!5m2!1sen!2sin"
                width="100%"
                height="170"
                style={{ border: "0" }}
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
      <div className="fotterbottom fwidth">
        <div className="row">
          {/* <div className="col-lg-5 col-md-6 col-sm-6">
               <ul className='socialMedia'>   
                  <li><Link to="/" target="_blank"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/instagram.png" alt="AFS" /></Link></li>
                  <li><Link to="/" target="_blank"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/facebook.png" alt="AFS" /></Link></li>
                  <li><Link to="/" target="_blank"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/yt.png" alt="AFS" /></Link></li>
                  <li><Link to="/" target="_blank"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/twitter.png" alt="AFS" /></Link></li>
             </ul>
               </div> */}
          <div className="col-lg-12 col-md-6 col-sm-6">
            <p className="login">
              <Link to="https://tafs.campuscare.info/" target="_blank">
                Login{" "}
              </Link>
            </p>
          </div>
        </div>
      </div>
      <div className="copyright">
        ©️ {getdate} TAFS | Designed & developed by Entab Infotech: CampusCare®️
      </div>
    </>
  );
};

export default Footer;
